import React from 'react';
import {  
    Grid, 
    Typography,
    Box,
    Container,
    styled,
    Card,
    CardContent,
} from '@mui/material';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import SafetyCheckIcon from '@mui/icons-material/SafetyCheck';
import EngineeringIcon from '@mui/icons-material/Engineering';
import SpeedIcon from '@mui/icons-material/Speed';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

const Content = () => {
    const Section = styled(Box)(({ theme }) => ({
        padding: theme.spacing(10, 0),
        background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
    }));

    const SectionTitle = styled(Typography)(({ theme }) => ({
        fontFamily: "'Outfit', 'Roboto', sans-serif",
        fontWeight: 800,
        fontSize: 'clamp(2rem, 4vw, 3rem)',
        textAlign: 'center',
        marginBottom: theme.spacing(2),
        background: 'linear-gradient(135deg, #FF6B35 0%, #FF8C42 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
    }));

    const SectionSubtitle = styled(Typography)(({ theme }) => ({
        textAlign: 'center',
        color: '#64748b',
        fontSize: '1.1rem',
        marginBottom: theme.spacing(8),
        maxWidth: '800px',
        marginLeft: 'auto',
        marginRight: 'auto',
        lineHeight: 1.8,
    }));

    const ServiceCard = styled(Card)(({ theme }) => ({
        height: '100%',
        borderRadius: '16px',
        border: '1px solid rgba(0, 0, 0, 0.08)',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        background: '#fff',
        '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: '0 12px 40px rgba(255, 107, 53, 0.15)',
            borderColor: '#FF6B35',
        },
    }));

    const IconBox = styled(Box)(({ theme }) => ({
        width: '60px',
        height: '60px',
        borderRadius: '12px',
        background: 'linear-gradient(135deg, #FF6B35 0%, #FF8C42 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: theme.spacing(2),
        '& svg': {
            fontSize: '1.8rem',
            color: '#fff',
        },
    }));

    const ServiceTitle = styled(Typography)(({ theme }) => ({
        fontFamily: "'Outfit', 'Roboto', sans-serif",
        fontWeight: 700,
        fontSize: '1.25rem',
        color: '#1e293b',
        marginBottom: theme.spacing(1),
    }));

    const ServiceDescription = styled(Typography)({
        fontSize: '0.95rem',
        color: '#64748b',
        lineHeight: 1.7,
    });

    const services = [
        {
            icon: <PrecisionManufacturingIcon />,
            title: 'Advanced Equipment',
            description: 'State-of-the-art cranes with lifting capacities from 10 to 200 tons for all your project needs.',
        },
        {
            icon: <SafetyCheckIcon />,
            title: 'Safety First',
            description: 'Rigorous safety protocols and certified equipment ensuring zero-incident operations.',
        },
        {
            icon: <EngineeringIcon />,
            title: 'Expert Operators',
            description: 'Highly trained and certified crane operators with years of hands-on experience.',
        },
        {
            icon: <SpeedIcon />,
            title: 'Quick Response',
            description: 'Rapid deployment and efficient service to keep your projects on schedule.',
        },
        {
            icon: <SupportAgentIcon />,
            title: '24/7 Support',
            description: 'Round-the-clock customer support and emergency assistance whenever you need it.',
        },
        {
            icon: <VerifiedUserIcon />,
            title: 'Certified Service',
            description: 'Fully licensed and insured operations meeting all industry standards and regulations.',
        },
    ];

    return (
        <Section component="section">
            <Container maxWidth="lg">
                <SectionTitle variant="h2">
                    Our Services & Capabilities
                </SectionTitle>
                <SectionSubtitle>
                    Perumal Crane Services offers comprehensive crane rental solutions with a commitment 
                    to excellence, safety, and customer satisfaction. Discover what sets us apart.
                </SectionSubtitle>

                <Grid container spacing={4}>
                    {services.map((service, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <ServiceCard>
                                <CardContent sx={{ p: 3 }}>
                                    <IconBox>
                                        {service.icon}
                                    </IconBox>
                                    <ServiceTitle>
                                        {service.title}
                                    </ServiceTitle>
                                    <ServiceDescription>
                                        {service.description}
                                    </ServiceDescription>
                                </CardContent>
                            </ServiceCard>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Section>
    );
};

export default Content;
